import { NavLink } from "react-router-dom";
import { Modal, Button, Row } from "antd";

const LoanProductModal = ({ isModalOpen, onCancel, onOkay, product }) => {
  console.log("payday product is ", product);

  return (
    <Modal
      title={<p className="text-center">{product.title}</p>}
      open={isModalOpen}
      onOk={onOkay}
      onCancel={onCancel}
      style={{
        width: "741px",
        height: "710px",
        gap: "0px",
        opacity: "1",
      }}
      footer={[
        <Row justify="start" key="footer-row">
          <Button
            key="close"
            type="primary"
            className="h-full px-4 py-1.5 shadow-none text-center"
          >
            <NavLink to="group-life-assurance">Apply Now</NavLink>
          </Button>
        </Row>,
      ]}
    >
      <div className="flex flex-col gap-1 ">
        <img
          src={product.image}
          alt={product.title}
          className="object-cover text-center rounded-[8px] h-[232px] w-[511px] m-auto"
        />

        <div className="py-3 px-0">
          <p className="text-[#929497] text-basef mb-4">
            {product.description}
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default LoanProductModal;
